// +----------------------------------------------------------------------
// | 「我的」页的会员入口行
// |
// | 原来是整张会员卡（渐变卡面 + 价目 + 兑换表单 + 扫码按钮）直接挂在
// | 「我的」页顶部，把资料页挤得很满，还和「改资料」这个主体抢注意力。
// | 现在这一行只回答一个问题：我是不是会员、到期什么时候；点进去
// | 才是完整的开通/续费流程（/vip）。
// |
// | 自己拉会员状态：状态只在这一行用，父组件不必为它多写一个 state。
// | 兑换成功从 /vip 返回时组件会重新挂载 → 状态自动刷新。
// +----------------------------------------------------------------------
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getMembership } from '../../api/order';
import '../EntrySwitches/EntrySwitches.less';
import './VipEntry.less';

/** 「2026-10-20 18:29:40」→「2026.10.20」 */
function prettyDate(value) {
  if (!value) return '';
  return String(value).slice(0, 10).replace(/-/g, '.');
}

export default function VipEntry() {
  const [loading, setLoading] = useState(true);
  const [membership, setMembership] = useState(null);
  const [quota, setQuota] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await getMembership();
        if (!mounted) return;
        setMembership(data.membership || null);
        setQuota(data.quota || null);
      } catch (e) {
        // 拉不到就显示默认免费态，不打扰用户
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const isMember = !!(membership && membership.is_member);
  const freeLimit = quota && quota.unlimited === false ? quota.limit : null;

  let sub = '不是会员';
  if (loading) sub = '正在查看…';
  else if (isMember) sub = `有效期至 ${prettyDate(membership.expire_at)}`;
  else if (freeLimit) sub = `不是会员 · 每天 ${freeLimit} 条对话`;

  return (
    <div className="card entry-switch-list vip-entry">
      <Link className="entry-switch-row" to="/vip">
        <span className={`entry-switch-row-icon ${isMember ? 'is-vip' : ''}`}>👑</span>
        <span className="entry-switch-row-main">
          <strong>想想会员</strong>
          <span className="muted">{sub}</span>
        </span>
        <span className="entry-switch-row-arrow">›</span>
      </Link>
    </div>
  );
}
